import { Component } from '@angular/core';

@Component({
  selector: 'vault-page-tabs',
  templateUrl: './page-tabs.component.html',
  styleUrls: ['./page-tabs.component.scss'],
  standalone: false,
})
export class PageTabsComponent {}
